import { lazy, Suspense } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const OrderApprovalListView = lazy(() =>
  import('../feature-sets/OrderApprovalListView').then((module) => ({
    default: module.OrderApprovalListView,
  }))
)

export const OrderApprovalsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.orderApprovalsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.orderApprovalsPageTitle),
        },
      ]}
    >
      <Suspense fallback={null}>
        <OrderApprovalListView />
      </Suspense>
    </Page>
  )
}
